module.exports = __webpack_public_path__ + "img/bootstrap-vue-logo.6bb064b5.svg";